// components/Loader.js
import React from 'react';
import './Loader.css';
import logo from '../Assets/logo.svg';
import DiamondAnimation from './DiamondAnimation';

export default function Loader() {
  return (
    <div className="loader-overlay">
      <div className='loader-logo'>
        <img src={logo} alt="" />
      </div>
        <DiamondAnimation/>
      {/* <div className="loader">
      </div> */}
    </div>
  );
}
